import { ColumnsType } from "antd/es/table";

export interface DataType {
  key: string;
  processStep: "Extruder" | "Rewinder #1" | "Rewinder #2";
  list: number;
  orderNumber: number;
  purchaseOrder: string;
  width: string;
  quantity: string;
  orderId: string;
  customer: string;
  base1: number;
  base2: number;
  plasticType: string;
  meters: number;
  setupTime: number;
  estimatedSpeed: number;
  estimatedHours: number;
  startDate: string;
  finishDate: string;
  status: "PENDING" | "FC" | "ACTIVE";
  carrier2?: number;
  timeUse: string;
}

export const statusColors: Record<string, React.CSSProperties> = {
  PENDING: { background: "#ff4d4f", color: "white" },
  FC: { background: "#ffec3d", color: "black" },
  ACTIVE: { background: "#52c41a", color: "white" },
};

export const plannerViewMockupData: DataType[] = [
  {
    key: "1",
    processStep: "Extruder",
    list: 1,
    orderNumber: 1,
    purchaseOrder: "2160",
    width: "1420",
    quantity: "10",
    orderId: "2806",
    customer: "Ahlstrom SD9211058 // SD7111040",
    base1: 40,
    base2: 20,
    plasticType: "LDPE + PP",
    meters: 74000,
    setupTime: 0.5,
    estimatedSpeed: 160,
    estimatedHours: 9,
    startDate: "2025-09-01 06:00",
    finishDate: "2025-09-01 17:04",
    status: "PENDING",
    timeUse: "8h 45m",
  },
  {
    key: "2",
    processStep: "Rewinder #1",
    list: 2,
    orderNumber: 1,
    purchaseOrder: "2145",
    width: "1390",
    quantity: "2",
    orderId: "2811",
    customer: "Ahlstrom SD9285050 // SD7127030",
    base1: 30,
    base2: 20,
    plasticType: "SBC 818",
    meters: 20000,
    setupTime: 0.5,
    estimatedSpeed: 160,
    estimatedHours: 3,
    startDate: "2025-09-01 17:04",
    finishDate: "2025-09-01 19:52",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "3",
    processStep: "Extruder",
    list: 3,
    orderNumber: 1,
    purchaseOrder: "745",
    width: "1370",
    quantity: "3",
    orderId: "2744",
    customer: "OptiPack WKL 130g 1260mm",
    base1: 120,
    base2: 10,
    plasticType: "LDPE",
    meters: 60000,
    setupTime: 0.5,
    estimatedSpeed: 150,
    estimatedHours: 3,
    startDate: "2025-09-03 21:45",
    finishDate: "2025-09-04 00:18",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "4",
    processStep: "Rewinder #2",
    list: 4,
    orderNumber: 1,
    purchaseOrder: "750",
    width: "1150 / 1040",
    quantity: "3 + 5?",
    orderId: "2477",
    customer: "Mintec OVAKO 165g 1160mm",
    base1: 70,
    base2: 65,
    plasticType: "LDPE",
    meters: 50000,
    setupTime: 0.5,
    estimatedSpeed: 100,
    estimatedHours: 10,
    startDate: "2025-09-04 07:44",
    finishDate: "2025-09-04 17:30",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "5",
    processStep: "Extruder",
    list: 5,
    orderNumber: 1,
    purchaseOrder: "735",
    width: "1140",
    quantity: "9",
    orderId: "2824",
    customer: "Smurfit KBA 137g 1110mm ? V.40",
    base1: 125,
    base2: 12,
    plasticType: "LDPE",
    meters: 70000,
    setupTime: 0.5,
    estimatedSpeed: 140,
    estimatedHours: 10,
    startDate: "2025-09-05 00:06",
    finishDate: "2025-09-05 09:52",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "6",
    processStep: "Rewinder #1",
    list: 6,
    orderNumber: 1,
    purchaseOrder: "760",
    width: "1600",
    quantity: "5",
    orderId: "3001",
    customer: "Staga Laminering, Blue/Blue",
    base1: 55,
    base2: 22,
    plasticType: "LDPE",
    meters: 25000,
    setupTime: 0.5,
    estimatedSpeed: 120,
    estimatedHours: 2,
    startDate: "2025-09-06 08:00",
    finishDate: "2025-09-06 12:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "7",
    processStep: "Extruder",
    list: 7,
    orderNumber: 1,
    purchaseOrder: "770",
    width: "1300",
    carrier2: 45,
    quantity: "7",
    orderId: "3002",
    customer: "Staga Laminering, White/White",
    base1: 60,
    base2: 30,
    plasticType: "LDPE + MB",
    meters: 30000,
    setupTime: 0.5,
    estimatedSpeed: 130,
    estimatedHours: 3,
    startDate: "2025-09-07 09:00",
    finishDate: "2025-09-07 14:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "8",
    processStep: "Rewinder #2",
    list: 8,
    orderNumber: 1,
    purchaseOrder: "780",
    width: "1500",
    quantity: "12",
    orderId: "3003",
    customer: "OptiPack Special Trial",
    carrier2: 45,
    base1: 75,
    base2: 25,
    plasticType: "PP",
    meters: 45000,
    setupTime: 1,
    estimatedSpeed: 140,
    estimatedHours: 4,
    startDate: "2025-09-08 06:00",
    finishDate: "2025-09-08 12:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "9",
    processStep: "Extruder",
    list: 9,
    orderNumber: 1,
    purchaseOrder: "790",
    width: "1450",
    quantity: "4",
    orderId: "3004",
    customer: "GEAB Lakan White 62g",
    base1: 95,
    base2: 45,
    plasticType: "LDPE",
    meters: 20000,
    setupTime: 0.5,
    carrier2: 45,
    estimatedSpeed: 125,
    estimatedHours: 2,
    startDate: "2025-09-09 07:30",
    finishDate: "2025-09-09 10:30",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "10",
    processStep: "Rewinder #1",
    list: 10,
    orderNumber: 1,
    purchaseOrder: "800",
    width: "1350",
    quantity: "8",
    orderId: "3005",
    customer: "Smurfit Test 150g",
    base1: 105,
    base2: 35,
    plasticType: "LDPE",
    meters: 32000,
    setupTime: 0.5,
    estimatedSpeed: 135,
    estimatedHours: 4,
    startDate: "2025-09-10 08:00",
    finishDate: "2025-09-10 14:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "11",
    processStep: "Rewinder #2",
    list: 11,
    orderNumber: 1,
    purchaseOrder: "810",
    width: "1400",
    quantity: "6",
    orderId: "3006",
    customer: "Ahlstrom Pilot Line",
    base1: 85,
    base2: 40,
    plasticType: "LDPE",
    meters: 27000,
    setupTime: 0.5,
    estimatedSpeed: 120,
    estimatedHours: 3,
    startDate: "2025-09-11 09:00",
    finishDate: "2025-09-11 13:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "12",
    processStep: "Extruder",
    list: 12,
    orderNumber: 1,
    purchaseOrder: "820",
    width: "1250",
    quantity: "15",
    orderId: "3007",
    customer: "OptiPack Test Roll",
    base1: 65,
    base2: 22,
    plasticType: "LDPE + PP",
    meters: 55000,
    setupTime: 0.5,
    estimatedSpeed: 145,
    estimatedHours: 6,
    startDate: "2025-09-12 06:00",
    finishDate: "2025-09-12 18:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "13",
    processStep: "Rewinder #1",
    list: 13,
    orderNumber: 1,
    purchaseOrder: "830",
    width: "1380",
    quantity: "9",
    orderId: "3008",
    customer: "Mintec New Test",
    base1: 70,
    base2: 33,
    plasticType: "LDPE",
    meters: 40000,
    setupTime: 0.5,
    estimatedSpeed: 130,
    estimatedHours: 5,
    startDate: "2025-09-13 07:00",
    finishDate: "2025-09-13 15:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "14",
    processStep: "Rewinder #2",
    list: 14,
    orderNumber: 1,
    purchaseOrder: "840",
    width: "1320",
    quantity: "11",
    orderId: "3009",
    customer: "GEAB Laminated",
    base1: 115,
    base2: 60,
    plasticType: "LDPE",
    meters: 50000,
    setupTime: 1,
    estimatedSpeed: 110,
    estimatedHours: 7,
    startDate: "2025-09-14 08:00",
    finishDate: "2025-09-14 17:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "15",
    processStep: "Extruder",
    list: 15,
    orderNumber: 1,
    purchaseOrder: "850",
    width: "1360",
    quantity: "13",
    orderId: "3010",
    customer: "Smurfit Special 2025",
    base1: 135,
    base2: 55,
    plasticType: "PP",
    meters: 60000,
    setupTime: 1,
    estimatedSpeed: 150,
    estimatedHours: 8,
    startDate: "2025-09-15 07:00",
    finishDate: "2025-09-15 15:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "16",
    processStep: "Rewinder #1",
    list: 16,
    orderNumber: 1,
    purchaseOrder: "860",
    width: "1280",
    quantity: "6",
    orderId: "3011",
    customer: "Ahlstrom WhiteLine",
    base1: 90,
    base2: 40,
    plasticType: "LDPE",
    meters: 28000,
    setupTime: 0.5,
    estimatedSpeed: 130,
    estimatedHours: 3,
    startDate: "2025-09-16 08:00",
    finishDate: "2025-09-16 12:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "17",
    processStep: "Rewinder #2",
    list: 17,
    orderNumber: 1,
    purchaseOrder: "870",
    width: "1400",
    quantity: "8",
    orderId: "3012",
    customer: "OptiPack Test Series",
    base1: 85,
    base2: 50,
    plasticType: "PP",
    meters: 36000,
    setupTime: 0.5,
    estimatedSpeed: 140,
    estimatedHours: 5,
    startDate: "2025-09-17 07:30",
    finishDate: "2025-09-17 14:30",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "18",
    processStep: "Extruder",
    list: 18,
    orderNumber: 1,
    purchaseOrder: "880",
    width: "1340",
    quantity: "10",
    orderId: "3013",
    customer: "Smurfit Pilot",
    base1: 100,
    base2: 45,
    plasticType: "LDPE + PP",
    meters: 42000,
    setupTime: 0.5,
    estimatedSpeed: 145,
    estimatedHours: 6,
    startDate: "2025-09-18 06:00",
    finishDate: "2025-09-18 13:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "19",
    processStep: "Rewinder #1",
    list: 19,
    orderNumber: 1,
    purchaseOrder: "890",
    width: "1500",
    quantity: "12",
    orderId: "3014",
    customer: "GEAB Laminated Roll",
    base1: 95,
    base2: 60,
    plasticType: "LDPE",
    meters: 48000,
    setupTime: 0.5,
    estimatedSpeed: 150,
    estimatedHours: 7,
    startDate: "2025-09-19 08:00",
    finishDate: "2025-09-19 17:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "20",
    processStep: "Rewinder #2",
    list: 20,
    orderNumber: 1,
    purchaseOrder: "900",
    width: "1320",
    quantity: "9",
    orderId: "3015",
    customer: "Ahlstrom Flexi Test",
    base1: 88,
    base2: 42,
    plasticType: "PP",
    meters: 35000,
    setupTime: 0.5,
    estimatedSpeed: 135,
    estimatedHours: 4,
    startDate: "2025-09-20 09:00",
    finishDate: "2025-09-20 15:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "21",
    processStep: "Extruder",
    list: 21,
    orderNumber: 1,
    purchaseOrder: "910",
    width: "1290",
    quantity: "7",
    orderId: "3016",
    customer: "Mintec Custom Roll",
    base1: 75,
    base2: 30,
    plasticType: "LDPE",
    meters: 26000,
    setupTime: 0.5,
    estimatedSpeed: 120,
    estimatedHours: 3,
    startDate: "2025-09-21 06:30",
    finishDate: "2025-09-21 11:30",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "22",
    processStep: "Rewinder #1",
    list: 22,
    orderNumber: 1,
    purchaseOrder: "920",
    width: "1410",
    quantity: "11",
    orderId: "3017",
    customer: "Smurfit New Gen",
    base1: 110,
    base2: 55,
    plasticType: "LDPE",
    meters: 50000,
    setupTime: 1,
    estimatedSpeed: 140,
    estimatedHours: 6,
    startDate: "2025-09-22 07:00",
    finishDate: "2025-09-22 13:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "23",
    processStep: "Rewinder #2",
    list: 23,
    orderNumber: 1,
    purchaseOrder: "930",
    width: "1330",
    quantity: "8",
    orderId: "3018",
    customer: "GEAB Strong Line",
    base1: 92,
    base2: 48,
    plasticType: "LDPE + MB",
    meters: 37000,
    setupTime: 0.5,
    estimatedSpeed: 125,
    estimatedHours: 4,
    startDate: "2025-09-23 08:30",
    finishDate: "2025-09-23 14:30",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "24",
    processStep: "Extruder",
    list: 24,
    orderNumber: 1,
    purchaseOrder: "940",
    width: "1440",
    quantity: "10",
    orderId: "3019",
    customer: "OptiPack 2025",
    base1: 120,
    base2: 50,
    plasticType: "LDPE",
    meters: 53000,
    setupTime: 1,
    estimatedSpeed: 135,
    estimatedHours: 7,
    startDate: "2025-09-24 07:00",
    finishDate: "2025-09-24 16:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "25",
    processStep: "Rewinder #1",
    list: 25,
    orderNumber: 1,
    purchaseOrder: "950",
    width: "1380",
    quantity: "13",
    orderId: "3020",
    customer: "Smurfit Heavy Duty",
    base1: 130,
    base2: 65,
    plasticType: "PP",
    meters: 60000,
    setupTime: 1,
    estimatedSpeed: 150,
    estimatedHours: 8,
    startDate: "2025-09-25 06:00",
    finishDate: "2025-09-25 15:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "26",
    processStep: "Rewinder #2",
    list: 26,
    orderNumber: 1,
    purchaseOrder: "960",
    width: "1260",
    quantity: "5",
    orderId: "3021",
    customer: "Ahlstrom Test Line",
    base1: 70,
    base2: 25,
    plasticType: "LDPE",
    meters: 22000,
    setupTime: 0.5,
    estimatedSpeed: 110,
    estimatedHours: 2,
    startDate: "2025-09-26 09:00",
    finishDate: "2025-09-26 11:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "27",
    processStep: "Extruder",
    list: 27,
    orderNumber: 1,
    purchaseOrder: "970",
    width: "1470",
    quantity: "14",
    orderId: "3022",
    customer: "GEAB New Roll",
    base1: 125,
    base2: 60,
    plasticType: "LDPE + PP",
    meters: 64000,
    setupTime: 1,
    estimatedSpeed: 145,
    estimatedHours: 9,
    startDate: "2025-09-27 06:00",
    finishDate: "2025-09-27 18:00",
    status: "FC",
    timeUse: "4h 10m",
  },
  {
    key: "28",
    processStep: "Rewinder #1",
    list: 28,
    orderNumber: 1,
    purchaseOrder: "980",
    width: "1400",
    quantity: "7",
    orderId: "3023",
    customer: "Smurfit High Speed",
    base1: 115,
    base2: 55,
    plasticType: "LDPE",
    meters: 45000,
    setupTime: 0.5,
    estimatedSpeed: 155,
    estimatedHours: 6,
    startDate: "2025-09-28 07:00",
    finishDate: "2025-09-28 13:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
  {
    key: "29",
    processStep: "Rewinder #2",
    list: 29,
    orderNumber: 1,
    purchaseOrder: "990",
    width: "1360",
    quantity: "9",
    orderId: "3024",
    customer: "OptiPack Advanced",
    base1: 105,
    base2: 50,
    plasticType: "LDPE",
    meters: 50000,
    setupTime: 1,
    estimatedSpeed: 135,
    estimatedHours: 7,
    startDate: "2025-09-29 08:00",
    finishDate: "2025-09-29 15:00",
    status: "PENDING",
    timeUse: "4h 10m",
  },
  {
    key: "30",
    processStep: "Extruder",
    list: 30,
    orderNumber: 1,
    purchaseOrder: "1000",
    width: "1500",
    quantity: "15",
    orderId: "3025",
    customer: "Demo Company Mock Row",
    base1: 140,
    base2: 70,
    plasticType: "PP",
    meters: 70000,
    setupTime: 1,
    estimatedSpeed: 160,
    estimatedHours: 10,
    startDate: "2025-09-30 07:00",
    finishDate: "2025-09-30 17:00",
    status: "ACTIVE",
    timeUse: "4h 10m",
  },
];

export const plannerViewColumns: ColumnsType<DataType> = [
  {
    key: "sort",
    width: 40,
  },
  { title: "Process Step", dataIndex: "processStep", key: "processStep" },
  { title: "Time Use", dataIndex: "timeUse", key: "timeUse", width: 100 },
  { title: "List", dataIndex: "list", key: "list" },
  { title: "Order Number", dataIndex: "orderNumber", key: "orderNumber" },
  { title: "Purchase Order", dataIndex: "purchaseOrder", key: "purchaseOrder" },
  { title: "Width", dataIndex: "width", key: "width" },
  { title: "Quantity", dataIndex: "quantity", key: "quantity" },
  { title: "Order Number (ID)", dataIndex: "orderId", key: "orderId" },
  { title: "Customer", dataIndex: "customer", key: "customer" },
  { title: "Carrier #1 gsm", dataIndex: "base1", key: "base1" },
  { title: "Barrier #1 gsm", dataIndex: "base2", key: "base2" },
  {
    title: "Carrier #2 gsm",
    dataIndex: "carrier2",
    key: "carrier2",
    render: (value) => value ?? "-",
  },

  { title: "Plastic Type", dataIndex: "plasticType", key: "plasticType" },
  { title: "Meters", dataIndex: "meters", key: "meters" },
  { title: "Setup Time", dataIndex: "setupTime", key: "setupTime" },
  {
    title: "Estimated Speed",
    dataIndex: "estimatedSpeed",
    key: "estimatedSpeed",
  },
  {
    title: "Estimated Hours",
    dataIndex: "estimatedHours",
    key: "estimatedHours",
  },
  { title: "Start Date", dataIndex: "startDate", key: "startDate" },
  { title: "Finish Date", dataIndex: "finishDate", key: "finishDate" },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => {
      const style = statusColors[status] || {};
      return (
        <span
          style={{
            display: "inline-block",
            padding: "2px 10px",
            borderRadius: 4,
            fontWeight: 600,
            textAlign: "center",
            minWidth: 90,
            ...style,
          }}
        >
          {status}
        </span>
      );
    },
  },
];
